/* SSTeche + ITXchange theme script. No dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ITX = window.ITX || {};

  /* ---------- validation ---------- */
  function setErr(input, msg) {
    var fld = input.closest('.fld');
    var slot = fld && fld.querySelector('.err');
    if (fld) fld.classList.toggle('bad', !!msg);
    if (slot) slot.textContent = msg || '';
    if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
  }
  function checkField(input) {
    var v = (input.value || '').trim();
    if (input.required && !v) { setErr(input, 'This field is required.'); return false; }
    if (v && input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { setErr(input, 'Enter a valid email address.'); return false; }
    if (v && input.type === 'tel' && v.replace(/\D/g, '').length < 7) { setErr(input, 'Enter a valid phone number.'); return false; }
    setErr(input, ''); return true;
  }
  function validate(scope) {
    var ok = true, first = null;
    $$('input,select,textarea', scope).forEach(function (i) {
      if (i.type === 'hidden' || i.closest('[hidden]')) return;
      if (!checkField(i)) { ok = false; if (!first) first = i; }
    });
    if (first) first.focus();
    return ok;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.hasAttribute('novalidate')) return;
    if (f.hasAttribute('data-search')) return;
    if (!validate(f)) e.preventDefault();
  });
  document.addEventListener('focusout', function (e) {
    var i = e.target;
    if (i.matches && i.matches('.fld input, .fld select, .fld textarea') && i.closest('form[novalidate]')) checkField(i);
  });

  /* ---------- dropdowns / nav ---------- */
  function closeDD(except) {
    $$('.dd.open').forEach(function (d) { if (d !== except) { d.classList.remove('open'); var b = $('button', d); if (b) b.setAttribute('aria-expanded', 'false'); } });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act]');
    if (!t) { if (!e.target.closest('.dd')) closeDD(); if (!e.target.closest('[data-search]')) { var sg = $('#sugg'); if (sg) sg.hidden = true; } return; }
    var act = t.getAttribute('data-act');
    switch (act) {
      case 'dd': var dd = t.closest('.dd'); var open = !dd.classList.contains('open'); closeDD(dd); dd.classList.toggle('open', open); t.setAttribute('aria-expanded', open); break;
      case 'mnav': var m = $('#mnav'); var o = !m.classList.contains('open'); m.classList.toggle('open', o); t.setAttribute('aria-expanded', o); break;
      case 'life':
        var wrap = t.closest('[data-life]'); var i = t.getAttribute('data-i');
        $$('[data-act="life"]', wrap).forEach(function (b) { b.setAttribute('aria-selected', b === t ? 'true' : 'false'); });
        $$('[data-lifepanel]', wrap).forEach(function (p) { p.hidden = p.getAttribute('data-lifepanel') !== i; });
        break;
      case 'promise':
        var pw = t.closest('[data-promise]'); var pi = t.getAttribute('data-i');
        $$('[data-act="promise"]', pw).forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
        $$('[data-promisetext]', pw).forEach(function (p) { p.hidden = p.getAttribute('data-promisetext') !== pi; });
        break;
      case 'roleteam':
        var rw = t.closest('[data-roles]'); var team = t.getAttribute('data-t');
        $$('[data-act="roleteam"]', rw).forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
        $$('[data-team]', rw).forEach(function (c) { c.hidden = !!team && c.getAttribute('data-team') !== team; });
        break;
      case 'apply':
        var sel = $('#ap-role'); if (sel) { for (var k = 0; k < sel.options.length; k++) if (sel.options[k].text === t.getAttribute('data-role')) sel.selectedIndex = k; }
        break;
      case 'qnext':
        var s1 = t.closest('[data-step]'); if (!validate(s1)) break;
        s1.hidden = true; var s2 = s1.parentNode.querySelector('[data-step="2"]'); s2.hidden = false; var f2 = $('input,select,textarea', s2); if (f2) f2.focus(); break;
      case 'qback':
        var st = t.closest('[data-step]'); st.hidden = true; st.parentNode.querySelector('[data-step="1"]').hidden = false; break;
      case 'bot': var bp = $('#botpanel'); bp.hidden = !bp.hidden; t.setAttribute('aria-expanded', !bp.hidden); if (!bp.hidden) $('#botq').focus(); break;
      case 'botclose': $('#botpanel').hidden = true; var bb = $('[data-act="bot"]'); if (bb) bb.setAttribute('aria-expanded', 'false'); break;
      case 'botq': botAsk(t.getAttribute('data-q')); break;
      case 'pq': var q = $('#pq'); var n = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(t.getAttribute('data-d'), 10)); q.value = n; break;
      case 'pimg': showMedia(t.getAttribute('data-media')); break;
      case 'stickyadd': var pf = $('#product-form'); if (pf) { if (pf.requestSubmit) pf.requestSubmit(); else pf.submit(); } break;
      case 'flttoggle': var fb = $('#flt-box'); var fo = !fb.classList.contains('open'); fb.classList.toggle('open', fo); t.setAttribute('aria-expanded', fo); break;
      case 'copylink':
        var url = location.href;
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { t.textContent = 'Copied'; setTimeout(function () { t.textContent = 'Copy link'; }, 1800); });
        break;
      case 'discount': applyDiscount(); break;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDD(); var bp = $('#botpanel'); if (bp && !bp.hidden) { bp.hidden = true; var b = $('[data-act="bot"]'); if (b) b.focus(); } }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-discount]')) { e.preventDefault(); applyDiscount(); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-autosubmit]')) t.form.submit();
    if (t.closest && t.closest('[data-filters]')) t.closest('form').submit();
    if (t.matches('[data-sort]')) { var u = new URL(location.href); u.searchParams.set('sort_by', t.value); u.searchParams.delete('page'); location.href = u.toString(); }
    if (t.matches('[data-act="dealf"]')) applyDeals();
    if (t.matches('[data-opt]')) onVariantChange();
  });
  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('[data-confirm]') && !window.confirm('Delete this address?')) e.preventDefault();
  });

  /* ---------- estimator ---------- */
  var est = $('[data-est]');
  if (est) {
    var fmt = function (n) { return '$' + Math.round(n).toLocaleString('en-US'); };
    var calc = function () {
      var dt = $('#est-dt').value, qty = Math.max(0, parseInt($('#est-qty').value, 10) || 0), cd = $('#est-cd').value;
      var r = (est.getAttribute('data-' + dt) || '0,0').split(',').map(Number);
      var m = cd === 'w' ? 1 : (cd === 'm' ? Number(est.getAttribute('data-mixed')) / 100 : Number(est.getAttribute('data-bad')) / 100);
      var out = $('#est-out');
      out.textContent = qty > 0 ? fmt(r[0] * qty * m) + ' – ' + fmt(r[1] * qty * m) : '—';
    };
    ['#est-dt', '#est-qty', '#est-cd'].forEach(function (s) { $(s).addEventListener('input', calc); $(s).addEventListener('change', calc); });
    calc();
  }

  /* ---------- article table of contents ---------- */
  var toc = $('[data-toc]'), prose = $('[data-prose]');
  if (toc && prose) {
    var hs = $$('h2', prose);
    if (!hs.length) { toc.hidden = true; }
    hs.forEach(function (h, i) {
      h.id = h.id || 'sec' + (i + 1);
      var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = (i + 1) + '. ' + h.textContent; toc.appendChild(a);
    });
  }

  /* ---------- deals filter (home) ---------- */
  function applyDeals() {
    var w = $('[data-deals]'); if (!w) return;
    var f = {}; $$('[data-act="dealf"]', w).forEach(function (s) { f[s.getAttribute('data-k')] = s.value; });
    var shown = 0;
    $$('#deals .pcard', w).forEach(function (c) {
      var p = parseFloat(c.getAttribute('data-price')) || 0;
      var ok = (!f.brand || c.getAttribute('data-brand') === f.brand) && (!f.grade || c.getAttribute('data-grade') === f.grade) &&
               (!f.ram || c.getAttribute('data-ram') === f.ram) &&
               (!f.price || (f.price === 'u300' ? p < 300 : f.price === 'u500' ? p < 500 : p >= 500));
      c.hidden = !ok; if (ok) shown++;
    });
    var em = $('#deals-empty'); if (em) em.hidden = shown > 0;
  }

  /* ---------- product page ---------- */
  var pvData = null;
  try { var pj = $('#pv-json'); if (pj) pvData = JSON.parse(pj.textContent); } catch (e) { pvData = null; }
  function showMedia(id) {
    var tpl = $('[data-mediatpl="' + id + '"]'); var main = $('#pmain'); if (!tpl || !main) return;
    main.innerHTML = ''; main.appendChild(tpl.content.cloneNode(true));
    $$('.thumbs button').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-media') === String(id) ? 'true' : 'false'); });
  }
  function onVariantChange() {
    if (!pvData) return;
    var vals = [];
    $$('[data-opt]:checked').forEach(function (r) { vals[parseInt(r.getAttribute('data-opt'), 10)] = r.value; });
    var v = pvData.filter(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); })[0];
    var price = $('#pprice'), add = $('#padd'), av = $('#pavail');
    if (!v) { if (add) { add.disabled = true; add.textContent = 'Unavailable'; } if (av) av.textContent = 'Unavailable'; return; }
    $('#pvid').value = v.id;
    var tpl = $('[data-vp="' + v.id + '"]');
    if (tpl && price) { price.innerHTML = tpl.innerHTML; var sp = $('#spprice'); if (sp) sp.innerHTML = tpl.innerHTML; }
    if (add) { add.disabled = !v.available; add.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    var sb = $('[data-act="stickyadd"]'); if (sb) sb.disabled = !v.available;
    if (av) { av.textContent = v.available ? 'In stock' : 'Sold out'; av.className = 'avail' + (v.available ? '' : ' out'); }
    var g = v.options.filter(function (o) { return /^Grade /i.test(o); })[0], gb = $('#pgrade');
    if (gb && g) { gb.hidden = false; gb.textContent = g; gb.className = 'badge ' + g.replace(/^Grade /i, '').trim(); }
    if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
    if (window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
  }

  /* ---------- discount code ---------- */
  function applyDiscount() {
    var i = $('[data-discount]'); if (!i) return;
    var c = i.value.trim(); var slot = $('#e-dc');
    if (!c) { if (slot) slot.textContent = 'Enter a discount code.'; i.focus(); return; }
    location.href = '/discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent('/cart');
  }

  /* ---------- predictive search ---------- */
  var sf = $('[data-search]');
  if (sf && ITX.searchUrl) {
    var inp = $('input[type=search]', sf), box = $('#sugg'), timer = null, ctl = null;
    var render = function (items, q) {
      box.innerHTML = '';
      if (!items.length) { var d = document.createElement('div'); d.style.padding = '14px'; d.className = 'mut'; d.textContent = 'No matches for “' + q + '”.'; box.appendChild(d); }
      items.forEach(function (p) {
        var a = document.createElement('a'); a.href = p.url;
        if (p.image) { var im = document.createElement('img'); im.src = p.image; im.alt = ''; im.width = 40; im.height = 40; a.appendChild(im); }
        var s = document.createElement('span'); s.textContent = p.title; a.appendChild(s);
        if (p.price) { var pr = document.createElement('b'); pr.style.marginLeft = 'auto'; pr.textContent = p.price; a.appendChild(pr); }
        box.appendChild(a);
      });
      var all = document.createElement('a'); all.href = sf.action + '?type=product&q=' + encodeURIComponent(q); all.style.fontWeight = '600'; all.textContent = 'See all results'; box.appendChild(all);
      box.hidden = false;
    };
    inp.addEventListener('input', function () {
      var q = inp.value.trim(); clearTimeout(timer);
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(function () {
        if (ctl && ctl.abort) ctl.abort(); ctl = window.AbortController ? new AbortController() : null;
        fetch(ITX.searchUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5', ctl ? { signal: ctl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var list = (j.resources && j.resources.results && j.resources.results.products) || [];
            render(list.map(function (p) { return { title: p.title, url: p.url, image: p.image, price: p.price }; }), q);
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- assistant ---------- */
  var KB = [
    { k: /service|offer|do you do/, a: 'We offer six services: Lifecycle Management, Refurbished Assets, Infra & Asset Leasing, Strategic IT Consulting, Maximizing Asset Recovery and Data Sanitization.', l: ['All services', '/pages/services'] },
    { k: /buy|laptop|refurb|macbook|shop|store|price/, a: 'Single refurbished laptops are sold on ITXchange. Each device is tested, graded and comes with a 3-month warranty (T&C apply), 10-day returns and the original adapter.', l: ['Shop laptops', '/collections/laptops'] },
    { k: /sell|buyback|retire|recover|pickup|worth|value/, a: 'We buy back retired IT assets with on-site pickup. Use the estimate tool on the home page or send us a request.', l: ['Request a quote', '/pages/maximizing-asset-recovery'] },
    { k: /lease|rent/, a: 'We offer flexible leasing for laptops, desktops and infrastructure.', l: ['Leasing', '/pages/infra-asset-leasing'] },
    { k: /data|erase|wipe|sanitiz|secure/, a: 'We erase data to industry standards and document it per device.', l: ['Data sanitization', '/pages/data-sanitization'] },
    { k: /grade|condition/, a: 'Grades A, B and C describe cosmetic condition only. Every device is tested the same way.', l: ['Grading guide', '/pages/grading'] },
    { k: /job|career|hiring|work with/, a: 'See our open roles and apply online.', l: ['Careers', '/pages/careers'] },
    { k: /contact|phone|call|email|address|office|where/, a: 'Our main head office is in Nehru Place, New Delhi, with a branch in Sharjah, Dubai, UAE, and procurement across the globe.', l: ['Contact us', '/pages/contact-us'] },
    { k: /warranty|return|ship|deliver/, a: 'Laptops come with a 3-month warranty (T&C apply) and 10-day returns. We currently ship across India. Full terms are on our policy pages.', l: ['Warranty', '/pages/warranty'] }
  ];
  function addMsg(text, who, link) {
    var c = $('#chat'); var d = document.createElement('div'); d.className = 'msg ' + who; d.textContent = text;
    if (link) { d.appendChild(document.createElement('br')); var a = document.createElement('a'); a.href = link[1]; a.className = 'lk'; a.textContent = link[0] + ' →'; d.appendChild(a); }
    c.appendChild(d); c.scrollTop = c.scrollHeight;
  }
  function botAsk(q) {
    q = (q || '').trim(); if (!q) return; addMsg(q, 'me');
    var hit = KB.filter(function (r) { return r.k.test(q.toLowerCase()); })[0];
    setTimeout(function () {
      if (hit) addMsg(hit.a, 'bot', hit.l); else addMsg('I can help with services, refurbished laptops, buyback, leasing and careers. For anything else, send us a message.', 'bot', ['Contact us', '/pages/contact-us']);
    }, 250);
  }
  var bf = $('#botform');
  if (bf) bf.addEventListener('submit', function (e) { e.preventDefault(); var i = $('#botq'); botAsk(i.value); i.value = ''; });
})();
